import React, { lazy } from 'react';
const cld = (path: string) => `https://res.cloudinary.com/dowzlbqlz/image/upload/f_auto,q_auto,w_300,c_limit/${path}`;
const tomes = [{
  number: '01',
  title: 'Sistema de Primera Consulta',
  desc: 'De la anamnesis al plan en 60 min.',
  image: cld('v1778383457/hf_20260510_031333_e32efef4-d0dd-463d-bda2-d570cc5fb28d_besl88.webp')
}, {
  number: '02',
  title: '30 Planes Listos para Personalizar',
  desc: 'Por patología, edad y objetivo.',
  image: cld('v1778383463/hf_20260510_031504_2fdf1995-89a0-4535-94d6-2fc87d41a682_behz9y.webp')
}, {
  number: '03',
  title: 'Educación Alimentaria Lista',
  desc: 'Láminas e infografías para entregar.',
  image: cld('v1778383467/hf_20260510_031729_03d03750-f9b4-4ce5-9733-7c98e34b7a47_wdzbya.webp')
}, {
  number: '04',
  title: 'El Paciente que Vuelve',
  desc: 'Seguimiento y adherencia a largo plazo.',
  image: cld('v1778383471/hf_20260510_031823_ec4fef6d-5367-4431-b91f-cc2541172638_weekco.webp')
}, {
  number: '05',
  title: '100 Recetas Clínicas',
  desc: 'Adaptadas al contexto argentino.',
  image: cld('v1778383475/hf_20260510_031836_9a1ecfa3-d239-45ff-8154-d842b6ca35e8_ars8yu.webp')
}, {
  number: '06',
  title: 'Nutricionista de Alto Valor',
  desc: 'Honorarios, marca y rentabilidad.',
  image: cld('v1778383480/hf_20260510_031856_7e6854d5-cabd-4958-839d-18ba33eb8f43_jputll.webp')
}];
const bonuses = [{
  num: '01',
  title: 'Guía de Pacientes Difíciles',
  price: '$12.000'
}, {
  num: '02',
  title: 'Scripts de WhatsApp',
  price: '$9.000'
}, {
  num: '03',
  title: 'Protocolo de Alta del Paciente',
  price: '$10.000'
}, {
  num: '04',
  title: 'Modelos de Informes para Médicos',
  price: '$9.000'
}, {
  num: '05',
  title: 'Guía Práctica de Antropometría',
  price: '$8.000'
}, {
  num: '06',
  title: '15 Casos Clínicos Resueltos',
  price: '$10.000'
}];
export function ProductShowcase() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(255,255,255) 0%, rgb(240,253,244) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-283">
      <div className="mx-auto max-w-4xl" data-id="element-284">
        {/* Level Badge */}
        <div className="flex items-center justify-center mb-4" data-id="element-285">
          <span className="text-[10px] font-black text-white bg-green-700 rounded-full px-3 py-1 tracking-wide" data-id="element-286">
            NIVEL 1
          </span>
        </div>

        {/* Heading */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-1" data-id="element-287">
          🥑 Megapack <span className="text-green-700" data-id="element-288">Nutrición Resuelta</span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-2" data-id="element-289">
          El sistema base completo para resolver tu consulta desde hoy.
        </p>
        <p className="text-center text-xs font-semibold text-green-700 m-0 mb-8" data-id="element-290">
          6 Tomos clínicos · 6 Bonos estratégicos · +580 páginas listas para
          usar
        </p>

        {/* Tomos grid con portadas */}
        <div className="grid grid-cols-3 sm:grid-cols-6 gap-3 mb-8" data-id="element-291">
          {tomes.map(tome => <div key={tome.number} className="flex flex-col items-center gap-1.5" data-id="element-292">
              <div className="w-full aspect-[3/4] rounded-xl bg-green-700/10 border border-green-700/20 overflow-hidden" data-id="element-293">
                {tome.image ? <img src={tome.image} alt={tome.title} width="150" height="200" loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-294" /> : <div className="w-full h-full flex items-center justify-center" data-id="element-295">
                    <span className="text-2xl font-black text-green-700/30" data-id="element-296">
                      {tome.number}
                    </span>
                  </div>}
              </div>
              <span className="text-[10px] font-black text-gray-800 text-center leading-tight" data-id="element-297">
                {tome.title}
              </span>
              <span className="text-[9px] text-gray-400 text-center leading-tight" data-id="element-298">
                {tome.desc}
              </span>
            </div>)}
        </div>

        {/* Bonos list */}
        <div className="bg-white border border-green-700/20 rounded-xl overflow-hidden shadow-sm mb-6" data-id="element-299">
          <div className="bg-green-700/5 border-b border-green-700/20 px-5 py-3" data-id="element-300">
            <h3 className="text-sm font-black text-green-700 m-0 tracking-wide" data-id="element-301">
              🎁 MÁS LOS 6 BONOS — Incluidos sin costo extra
            </h3>
          </div>
          <div className="divide-y divide-gray-100" data-id="element-302">
            {bonuses.map(bonus => <div key={bonus.num} className="flex items-center gap-4 px-5 py-2.5" data-id="element-303">
                <span className="shrink-0 text-sm font-black text-green-700/30 w-7 text-center" data-id="element-304">
                  {bonus.num}
                </span>
                <span className="flex-1 text-sm font-black text-gray-900 min-w-0" data-id="element-305">
                  {bonus.title}
                </span>
                <div className="shrink-0 flex items-center gap-2" data-id="element-306">
                  <span className="text-[10px] text-gray-400 line-through" data-id="element-307">
                    {bonus.price}
                  </span>
                  <span className="text-[10px] font-black text-white bg-green-700 rounded-full px-2 py-0.5" data-id="element-308">
                    GRATIS
                  </span>
                </div>
              </div>)}
          </div>
        </div>

        {/* Footer bar */}
        <div className="text-center rounded-xl px-5 py-4 shadow-sm" style={{
        backgroundColor: 'rgb(240,253,244)',
        border: '1px solid rgba(34,197,94,0.3)'
      }} data-id="element-309">
          <p className="text-xs font-bold uppercase tracking-widest text-green-700 m-0 mb-1" data-id="element-310">
            Todo esto resuelto desde hoy
          </p>
          <p className="text-sm text-gray-700 font-semibold m-0" data-id="element-311">
            6 tomos · 6 bonos · +580 páginas · Acceso inmediato
          </p>
          <p className="text-[11px] text-gray-400 font-medium m-0 mt-1" data-id="element-312">
            Lo que necesitás para entrar el lunes con todo listo.
          </p>
        </div>
      </div>
    </section>;
}